/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { AppPhase } from '../../models/communication/app-enums.model';
import { TableUpdate } from '../../models/communication/app-state.model';
import { CardValue } from '../../models/communication/cards.enum';
import { CardPosition } from '../../models/communication/games.model';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';
import { BlackjackCardPosition } from '../game-types/blackjack/blackjack.model';
import { CardState } from '../models/game-view.model';

// The last update is replayed on every phase change and after a reconnect, so each step
// works off the view state and is safe to apply twice.
export class BlackjackGameFlow extends GameFlowBase<GameBase> {
    override update(tableUpdate?: TableUpdate, appPhase?: AppPhase): void {
        if (appPhase === AppPhase.Decision) {
            this.game.showPlayerDecisionTime();
            return;
        }

        if (!this.game.isUpdateDataValid(tableUpdate)) {
            return;
        }

        if ('cardPosition' in tableUpdate) {
            if (tableUpdate.cardPosition === BlackjackCardPosition.HoleCard && tableUpdate.card === CardValue.Unknown) {
                this.game.updateCard(tableUpdate.cardPosition, CardState.Checked);
            } else {
                this.game.showCard(tableUpdate.cardPosition!, tableUpdate.card!);
            }

            this.game.showHandValue(tableUpdate);
        }

        // The dealer draws only after the players decide, which ends with the hole card turned up.
        const nextCardPosition = this.isHoleCardDown() ? undefined : tableUpdate.nextCardPosition;
        this.clearPrompts(nextCardPosition);

        if (nextCardPosition === BlackjackCardPosition.HoleCard) {
            this.game.showFaceDownMessage(nextCardPosition);
        } else if (nextCardPosition !== undefined) {
            this.game.showFaceUpMessage(nextCardPosition);
        } else if ('cardPosition' in tableUpdate && !this.isHoleCardDown()) {
            this.game.handleOutcome(tableUpdate);
        }
    }

    private isHoleCardDown(): boolean {
        return this.game.getCardState(BlackjackCardPosition.HoleCard) === CardState.Checked;
    }

    private clearPrompts(keepPosition?: CardPosition): void {
        for (const card of this.game.getCards()) {
            const isPrompt = card.state === CardState.MessageFaceUp || card.state === CardState.MessageFaceDown;

            if (isPrompt && card.position !== keepPosition) {
                this.game.updateCard(card.position, card.position > BlackjackCardPosition.HoleCard ? CardState.Hidden : CardState.Empty);
            }
        }
    }
}
